import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('RequestForm.Popups', {
    newContact: 'New Contact',
    newCustomer: 'New Customer',
});
